import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Skill } from './skill';

export interface SkillsStore {
  loaded$: Observable<boolean>;
  allSkills$: Observable<Skill[]>;
  init(): void;
  addSkill(skill: Skill): void;
  editSkill(skill: Skill): void;
  deleteSkill(skill: Skill): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const SKILLS_STORE = new InjectionToken<SkillsStore>('SKILLS_STORE');
